<template>
  <div>
    <p class="title is-5">
      {{ this.is_SUP ? $t('customer.labels.project') : $t('customer.labels.units') }}
    </p>
    <p
      v-if="$_.isEmpty(units)"
      class="subtitle is-6"
    >
      {{ this.is_SUP ? $t('customer.labels.noProject') : $t('customer.labels.noUnits') }}
    </p>
    <div class="flex flex-col gap-4">
      <UnitItem
        v-for="unit in units"
        :key="unit.id"
        :disabled="$_.isNil(projects[unit.attributes.project_id])"
        :group_customer="groupCustomer(unit.id)"
        :project="projects[unit.attributes.project_id]"
        :unit="unit"
      />
    </div>
  </div>
</template>

<script>
import UnitItem from '@/app/_employees/components/contacts/UnitItem.vue';
import { mapGetters } from 'vuex';
import { PROJECT_TYPES } from '@/app/data/model_constants.js';

export default {
  name: 'UnitList',
  components: { UnitItem },
  props: {
    customer: { type: Object, required: true },
    group_customers: { type: Array, required: true },
    units: {
      type: Object,
      default: null,
    },
    projects: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['current_client']),

    is_SUP() {
      return this.current_client.attributes.project_type === PROJECT_TYPES.SUP;
    },
  },
  methods: {
    groupCustomer(unit_id) {
      return _.find(this.group_customers, { attributes: { customer_id: this.customer.id, unit_id } });
    },
  },
};
</script>
